"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultMimeType: function() {
        return defaultMimeType;
    },
    getExtensions: function() {
        return getExtensions;
    },
    getMimeTypeFilter: function() {
        return getMimeTypeFilter;
    },
    isAllowedMimeTypeOrExtension: function() {
        return isAllowedMimeTypeOrExtension;
    },
    normalizeMimeType: function() {
        return normalizeMimeType;
    },
    normalizeMimeTypes: function() {
        return normalizeMimeTypes;
    }
});
const _interop_require_default = require("@swc/helpers/_/_interop_require_default");
const _mime = /*#__PURE__*/ _interop_require_default._(require("mime"));
const defaultMimeType = 'application/octet-stream';
function getMimeTypeFilter(mimeTypes, transform = (item)=>typeof item === 'string' ? item : defaultMimeType) {
    mimeTypes = normalizeMimeTypes(mimeTypes);
    return (item)=>{
        const mimeType = transform(item);
        return isAllowedMimeType(mimeType, mimeTypes);
    };
}
function isAllowedMimeType(mimeType, accepts) {
    mimeType = mimeType.toLowerCase();
    return accepts.some((type)=>mimeType.startsWith(type));
}
function isAllowedMimeTypeOrExtension(args) {
    // eslint-disable-next-line prefer-const
    let { mimeType, extension, accepts } = args;
    if (!(accepts == null ? void 0 : accepts.length)) return true;
    const normalizedAccepts = normalizeMimeTypes(accepts);
    mimeType = mimeType == null ? void 0 : mimeType.toLowerCase();
    extension = extension == null ? void 0 : extension.toLowerCase();
    const out = normalizedAccepts.some((type)=>{
        return type.includes('/') ? mimeType == null ? void 0 : mimeType.startsWith(type) : type === extension;
    });
    return out;
}
function normalizeMimeTypes(mimeTypes) {
    return mimeTypes.map((mimeType)=>normalizeMimeType(mimeType));
}
function normalizeMimeType(mimeType) {
    return mimeType.toLowerCase().replaceAll('*', '');
}
function getExtensions(acceptedFileTypes) {
    const extSet = new Set((acceptedFileTypes != null ? acceptedFileTypes : []).map((x)=>{
        if (x.endsWith('/*')) return x.slice(0, -2) + 's';
        if (x.includes('/')) {
            const ext = _mime.default.getExtension(x);
            return ext ? `.${ext}` : '';
        }
        return x;
    }));
    return [
        ...extSet.values()
    ].join(', ');
}

//# sourceMappingURL=mime.js.map